(() => {
  if (customElements.get('ip-logo-marquee')) return;
  customElements.define('ip-logo-marquee',class extends HTMLElement {
    connectedCallback() {
      this.classList.add('is-enhanced');
      this.abort = new AbortController();
      this.addEventListener('click',event => {
        const button = event.target.closest('[data-logo-pause]');
        if (!button) return;
        const paused = this.toggleAttribute('data-paused');
        button.setAttribute('aria-pressed',String(paused));
        button.setAttribute('aria-label',paused ? 'Play logo animation' : 'Pause logo animation');
        button.querySelector('[data-logo-pause-icon]').textContent = paused ? '▶' : 'Ⅱ';
      },{signal:this.abort.signal});
      this.addEventListener('shopify:block:select',() => this.setAttribute('data-paused',''),{signal:this.abort.signal});
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
})();
